import { Component, EventEmitter, OnInit, Output } from '@angular/core'
import { UntypedFormBuilder, UntypedFormGroup, FormsModule } from '@angular/forms'
import { ActivatedRoute, Router } from '@angular/router'
import * as CryptoJS from 'crypto-js'
import { environment } from '../../../../../environments/environment'
import { PDFSERVICE } from '../../../../@theme/services/pdfgetfiles.service'
import { NgClass, NgFor, NgIf } from '@angular/common';
import { PDFViewerComponent } from '../../pdfview.component';
import { FILE_ITEM_CLASS, SELECTED_FILE_ITEM_CLASS } from '../../file-list-classes'

@Component({
    selector: 'gd-tabcorrespondencefileslist',
    templateUrl: './tabfilesCorrespondencelist.component.html',
    styleUrls: ['./../../disclosure-forms/disclosure-forms.component.scss'],
    imports: [
        FormsModule,
        NgClass,
        NgFor,
        NgIf,
        PDFViewerComponent,
    ]
})
export class tabfilesCorrespondencelistComponent implements OnInit {
  @Output() corresponFilesChanged: EventEmitter<boolean> =
    new EventEmitter<boolean>()
  correspondfiles: boolean
  public disclosureSelectorForm: UntypedFormGroup
  public selectedFormData: Blob
  public pdfLoadError: string | null = null
  protected blotId: number
  fileList = []
  public selectedUrl: string | null = null
  public fileClass = FILE_ITEM_CLASS
  public selectedFileClass = SELECTED_FILE_ITEM_CLASS
  constructor(
    private pdfService: PDFSERVICE,
    private formBuilder: UntypedFormBuilder,
    private route: ActivatedRoute,
    private router: Router,
  ) {
    if (this.route.snapshot.queryParams['Rview']) {
      this.route.queryParams.subscribe((params) => {
        const getblotterClient = CryptoJS.AES.decrypt(
          params['Rview'],
          environment.securepw,
        ).toString(CryptoJS.enc.Utf8)
        this.blotId = Number(getblotterClient)
        //   alert(JSON.stringify(this.blotId))
      })
    }
  }
  extractFileNames(filePaths: string[]): any[] {
    return filePaths.map((filePath) => {
      const parts = filePath.split('\\')
      const fileName = parts[parts.length - 1]
      return { name: fileName, url: filePath } // Assuming you want to keep the full filePath as the URL
    })
  }
  ngOnInit(): void {
    this.pdfService.getPdfCorresponlist(this.blotId).subscribe((response) => {
      const fileNames = this.extractFileNames(response)
        .filter(f => f.name.toLowerCase().endsWith('.pdf'))
      this.fileList = fileNames
      if (response.length > 0 && this.fileList.length > 0) {
        this.correspondfiles = true
        // Auto-select the first file so the viewer is never empty
        this.onClickFile(this.fileList[0].url)
      } else {
        this.correspondfiles = false
      }
      this.corresponFilesChanged.emit(this.correspondfiles)
    })
  }
  onClickFile(f: string) {
   this.selectedUrl = f
   const normalizedPath = f.replace(/\\/g, '/');
  const lowerPath = normalizedPath.toLowerCase();

  let relativePath = normalizedPath; // fallback

  const variants = ['filemanager/', 'file manager/'];
  for (const variant of variants) {
    const index = lowerPath.indexOf(variant);
    if (index !== -1) {
      relativePath = normalizedPath.substring(index + variant.length);
      break;
    }
  }

  const formNames: string[] = [relativePath];
    this.pdfService.viewCorpdffile(formNames).subscribe({
      next: (response) => {
        this.selectedFormData = response
        this.pdfLoadError = null
      },
      error: (error) => {
        console.error('Error loading Correspondence PDF file:', error)
        this.pdfLoadError = 'Cannot view this Correspondence file because it is corrupted or unavailable'
        this.selectedFormData = null as any
      }
    })
  }
}
